import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import api, { getApiErrorMessage } from '../api';

function ResetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const navigate = useNavigate();
  
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) {
        setError('Недействительная или отсутствующая ссылка для сброса.');
        return;
    }
    if (password !== confirmPassword) {
        setError('Пароли не совпадают.');
        return;
    }

    setIsLoading(true);
    setError('');
    setMessage('');
    
    try {
      await api.post('/auth/reset-password', { token, new_password: password });
      setMessage('Пароль успешно изменен. Вы можете войти в систему.');
      setTimeout(() => navigate('/login'), 3000);
    } catch (err) {
      setError(getApiErrorMessage(err, 'Ошибка при сбросе пароля.'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Сброс пароля</h1>
        <p style={styles.subtitle}>
          Установите новый надежный пароль для вашего аккаунта.
        </p>
        
        {message && <div style={styles.successText}>{message}</div>}
        {error && <div style={styles.errorText}>{error}</div>}
        
        {!message && (
        <form onSubmit={handleSubmit}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Новый пароль</label>
            <input 
              type="password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              style={styles.input}
              placeholder="••••••••"
            />
          </div>
          
          <div style={styles.formGroup}>
            <label style={styles.label}>Подтвердите пароль</label>
            <input 
              type="password" 
              value={confirmPassword} 
              onChange={(e) => setConfirmPassword(e.target.value)} 
              required 
              style={styles.input}
              placeholder="••••••••"
            />
          </div>
          
          <button 
            type="submit" 
            style={styles.buttonSubmit}
            disabled={isLoading || !token}
          >
            {isLoading ? 'Сохранение...' : 'Сохранить пароль'}
          </button>
        </form>
        )}
        
        <div style={{ marginTop: '25px', textAlign: 'center' }}>
          <Link to="/login" style={styles.fpLink}>← Вернуться ко входу</Link>
        </div>
      </div>
    </div>
  );
}

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f7fa',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        padding: '20px'
    },
    card: {
        padding: '40px',
        backgroundColor: 'white',
        borderRadius: '16px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.05)',
        textAlign: 'center',
        maxWidth: '400px',
        width: '100%'
    },
    title: {
        margin: '0 0 10px 0',
        color: '#2d3748',
        fontSize: '24px',
        fontWeight: 'bold'
    },
    subtitle: {
        margin: '0 0 30px 0',
        color: '#718096',
        fontSize: '15px',
        lineHeight: '1.5'
    },
    formGroup: {
        marginBottom: '20px',
        textAlign: 'left'
    },
    label: {
        display: 'block',
        marginBottom: '8px',
        fontWeight: '600',
        color: '#4a5568',
        fontSize: '14px'
    },
    input: {
        width: '100%',
        padding: '12px',
        borderRadius: '8px',
        border: '1px solid #cbd5e0',
        boxSizing: 'border-box',
        fontSize: '16px',
        transition: 'border-color 0.2s',
        outline: 'none'
    },
    buttonSubmit: {
        width: '100%',
        padding: '12px',
        backgroundColor: '#3182ce',
        color: 'white',
        fontSize: '16px',
        fontWeight: 'bold',
        border: 'none',
        borderRadius: '8px',
        cursor: 'pointer',
        transition: 'background 0.2s',
        outline: 'none'
    },
    errorText: {
        color: '#e53e3e',
        marginBottom: '20px',
        padding: '12px',
        backgroundColor: '#fff5f5',
        borderRadius: '8px',
        border: '1px solid #feb2b2',
        fontSize: '14px',
        textAlign: 'left'
    },
    successText: {
        color: '#38a169',
        marginBottom: '20px',
        padding: '12px',
        backgroundColor: '#f0fff4',
        borderRadius: '8px',
        border: '1px solid #c6f6d5',
        fontSize: '14px',
        textAlign: 'left'
    },
    fpLink: {
        color: '#3182ce',
        textDecoration: 'none',
        fontSize: '14px',
        fontWeight: '500'
    }
};

export default ResetPassword;
